import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import { DateTime } from 'scaleflow/utils/date-time';

class BacklogInitiativesInitiativePlanningWorkstreamsUnfiledArchiveRoute extends Route {
  @service router;

  async model() {
    try {
      const allArchivedTfos = this.modelFor(
        'backlog.initiatives.initiative.planning.workstreams.unfiled',
      );

      const unfiledTfos = allArchivedTfos.filter(
        (tfo) => !tfo.get('workstream')?.get('id'),
      );

      let uniqueDates = this.groupByDate(unfiledTfos, 'created_at');
      let orderedDates = this.orderDates(uniqueDates);
      const { initiative } = this.paramsFor('backlog.initiatives.initiative');

      if (Object.keys(orderedDates).length === 0) {
        return { data: false, parent_id: initiative };
      } else {
        let formattedDates = this.formatDates(orderedDates);
        return { data: formattedDates, parent_id: initiative };
      }
    } catch (err) {
      console.log(err);
      const { initiative } = this.paramsFor('backlog.initiatives.initiative');
      this.router.transitionTo(
        'backlog.initiatives.initiative.workstreams',
        initiative,
      );
    }
  }

  formatDates(object) {
    for (const key in object) {
      let momentFormat = DateTime.from(key).calendar({
        sameDay: '[Today]',
        lastDay: '[Yesterday]',
        lastWeek: 'ddd, DD MMM YYYY',
        sameElse: 'ddd, DD MMM YYYY',
      });
      delete Object.assign(object, { [momentFormat]: object[key] })[key];
    }
    return object;
  }

  groupByDate(array, key) {
    return array.reduce(function (rv, x) {
      const dateKey = DateTime.from(x.get(key)).format('YYYY-MM-DD');
      (rv[dateKey] = rv[dateKey] || []).push(x);
      return rv;
    }, {});
  }

  orderDates(unordered) {
    return Object.keys(unordered)
      .sort()
      .reverse()
      .reduce((obj, key) => {
        obj[key] = unordered[key];
        return obj;
      }, {});
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativePlanningWorkstreamsUnfiledArchiveRoute,
);
